<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card card-default">
                <service-wizard-layout
                    title=""
                    subtitle=""
                    :parts="parts"
                    :onComplete="onComplete"
                    :validateStep="validateStep"
                >
                <template v-slot:pointsContract>
                    <form novalidate data-vv-scope="pointsContract">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" :class="{'has-error': errors.has('pointsContract.description')}">
                                    <label>Description</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="description"
                                        v-model="filledInSaleDefinition.requiredObjs.pointsContract.description"
                                        v-validate="'required'" 
                                    />
                                    <span class="has-error" v-if="errors.has('pointsContract.description')">
                                        {{errors.first('pointsContract.description')}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group" :class="{'has-error': errors.has('pointsContract.packageNumber')}">
                                    <label>Package</label>
                                    <v-select
                                        :options="filledInSaleDefinition.selectableOptions.pointsPak"
                                        placeholder="Select a package"
                                        name="packageNumber"
                                        :get-option-label="getLabel"
                                        v-model="filledInSaleDefinition.requiredObjs.pointsContract.basicPackageNumber"
                                        valueProp="basicPackageNumber"
                                        v-validate="'required'" 
                                    >
                                    </v-select>
                                    <span class="has-error" v-if="errors.has('pointsContract.packageNumber')">
                                        {{errors.first('pointsContract.packageNumber')}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
                </service-wizard-layout>
            </div>
        </div>
    </div>
</template>

<script>
import ServiceWizardLayout from '@/layouts/ServiceWizardLayout';

export default {
    components: {
        ServiceWizardLayout
    },
    props: {
        emptySaleDefinition: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            clientNumber: null,
            sales: [],
            parts: [
                {
                    name: "pointsContract",
                    displayName: "Points Contract Details",
                    icon: "fa-solid fa-file-contract"
                }
            ],
            filledInSaleDefinition: {
                requiredObjs: {
                    pointsContract: {}
                },
                selectableOptions: {
                    pointsPak: []
                }
            }
        }
    },
    mounted() {        
        this.clientNumber = this.$route.params.clientNumber;
        this.filledInSaleDefinition = this.emptySaleDefinition;
    },
    methods: {
        onComplete() {
            this.filledInSaleDefinition.requiredObjs.pointsContract.basicPackageNumber = parseInt(this.filledInSaleDefinition.requiredObjs.pointsContract.basicPackageNumber);
            this.$emit("createSale", this.filledInSaleDefinition);
        },
        validateStep(scope) {
            return this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        getLabel(data) {
            return `${data.description}`;
        },
    }
}
</script>
